const KEYCODE_MAPPING = {
  backspace: 8,
  tab: 9,
  enter: 13,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  delete: 46,
  a: 65,
  v: 86,
  x: 88,
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
  'numpad 0': 96,
  'numpad 1': 97,
  'numpad 2': 98,
  'numpad 3': 99,
  'numpad 4': 100,
  'numpad 5': 101,
  'numpad 6': 102,
  'numpad 7': 103,
  'numpad 8': 104,
  'numpad 9': 105,
}

const isNumericKey = (charCode) => [
  KEYCODE_MAPPING[0],
  KEYCODE_MAPPING[1],
  KEYCODE_MAPPING[2],
  KEYCODE_MAPPING[3],
  KEYCODE_MAPPING[4],
  KEYCODE_MAPPING[5],
  KEYCODE_MAPPING[6],
  KEYCODE_MAPPING[7],
  KEYCODE_MAPPING[8],
  KEYCODE_MAPPING[9],
  KEYCODE_MAPPING['numpad 0'],
  KEYCODE_MAPPING['numpad 1'],
  KEYCODE_MAPPING['numpad 2'],
  KEYCODE_MAPPING['numpad 3'],
  KEYCODE_MAPPING['numpad 4'],
  KEYCODE_MAPPING['numpad 5'],
  KEYCODE_MAPPING['numpad 6'],
  KEYCODE_MAPPING['numpad 7'],
  KEYCODE_MAPPING['numpad 8'],
  KEYCODE_MAPPING['numpad 9'],
].includes(charCode);

const isSpecialKey = (charCode) => [
  KEYCODE_MAPPING.backspace,
  KEYCODE_MAPPING.tab,
  KEYCODE_MAPPING.enter,
  KEYCODE_MAPPING.leftArrow,
  KEYCODE_MAPPING.upArrow,
  KEYCODE_MAPPING.rightArrow,
  KEYCODE_MAPPING.downArrow,
  KEYCODE_MAPPING.delete,
].includes(charCode);


export { KEYCODE_MAPPING, isNumericKey, isSpecialKey }